import BaseComponent from 'foundation/base-component';
import HtmlHelper from 'foundation/html-helper';
import ComponentsFactory from 'foundation/components-factory';
import api from '../../../general/js/api';
import pageSpinner from '../../../general/js/page-spinner';
import gtm from '../../../general/js/gtm';

class PreviousOpensComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.dataUrl = this.getAttribute(this.element, 'url');

        this.isFetching = false;

        this.choicesWrapperInstance = null;

        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.onClickLoadmore = this.onClickLoadmore.bind(this);
        this.init();
    }

    init() {
        if (this.refs.select) {
            this.choicesInstance();
        }

        if (this.refs.select) {
            this.addListener(this.refs.select, 'change', this.onChangeFilter);
        }

        if (this.refs.footer) {
            this.addListener(this.refs.footer, 'click', this.onClickLoadmore);
        }
    }

    onDestroy() {
        this.choicesWrapperInstance.destroy();
    }

    choicesInstance() {
        const randaSelect = 'randa-select';

        this.choicesWrapperInstance = new window.Choices(this.refs.select, {
            searchEnabled: false,
            itemSelectText: '',
            placeholder: false,
            shouldSort: false,
            classNames: {
                containerOuter: `
                    choices
                    ${randaSelect}
                `,
                containerInner: `
                    choices__inner
                    ${randaSelect}__inner
                `,
                list: `
                    choices__list
                    ${randaSelect}__list
                `,
                listDropdown: `
                    choices__list--dropdown
                    ${randaSelect}__list--dropdown
                `,
                listSingle: `
                    choices__list--single
                    ${randaSelect}__list--single
                `,
                item: `
                    choices__item
                    ${randaSelect}__item
                `,
                itemSelectable: `
                    choices__item--selectable
                    ${randaSelect}__item--selectable
                `,
                itemDisabled: `
                    choices__item--disabled
                    ${randaSelect}__item--disabled
                `,
                itemChoice: `
                    choices__item--choice
                    ${randaSelect}__item--choice
                `
            }
        });
    }

    onChangeFilter() {
        gtm.push('Select decade', 'Dropdown', this.refs.select.value);
        this.updateContent(this.refs.select.value, true);
    }

    onClickLoadmore(event) {
        if (event.target === this.refs.footer) return;

        const button = HtmlHelper.getParent(
            event.target,
            `[${this.getScopedAttribute('loadmore')}]`,
            true,
            this.refs.footer
        );

        if (!this.isFetching &&
            button
        ) {
            const decadeYear = this.getAttribute(button, 'prev-year');

            event.preventDefault();
            this.updateContent(decadeYear, false);
        }
    }

    updateContent(decadeYear, shouldCleanList) {
        this.isFetching = true;
        pageSpinner.show();

        this.getData(decadeYear).then((res) => {
            this.renderList(res.data.dataList, shouldCleanList);
            this.renderButton(res.data.button);

            this.isFetching = false;
            pageSpinner.hide();
        }).catch((err) => {
            console.log(err);
            this.isFetching = false;
            pageSpinner.hide();
        });
    }

    renderList(content, shouldClean) {
        if (shouldClean) {
            ComponentsFactory.getInstance().destroy(this.refs.listing);
            this.refs.listing.innerHTML = '';
        }

        if (content) {
            this.refs.listing.insertAdjacentHTML('beforeEnd', content);
            ComponentsFactory.getInstance().init(this.refs.listing);
        }
    }

    renderButton(content) {
        ComponentsFactory.getInstance().destroy(this.refs.footer);
        this.refs.footer.innerHTML = '';

        if (content) {
            this.refs.footer.insertAdjacentHTML('beforeEnd', content);
            ComponentsFactory.getInstance().init(this.refs.footer);
        }
    }

    getData(decadeYear) {
        if (!this.dataUrl) return Promise.reject(new Error('incorrect data URL'));

        this.isFetching = true;

        return api.get(this.dataUrl, { params: { decadeYear } });
    }
}

export default PreviousOpensComponent;
